import { configureStore, combineReducers } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
import { persistStore, persistReducer } from 'reduxjs-toolkit-persist'
import storage from 'reduxjs-toolkit-persist/lib/storage/session'
import { createMiddleware, createReducer } from 'async-selector-kit'
import { firebaseReducer } from 'react-redux-firebase'
import { reducer as RegisterReducer } from '../features/Register/reducer'
import { reducer as CreateLoginReducer } from '../features/Login/Create/reducer'
import { reducer as LoginReducer } from '../features/Login/reducer'
import { reducer as CreateProfileReducer } from '../features/Profile/reducer'
import { reducer as SelectUnitsReducer } from '../features/SelectUnits/reducer'
import { reducer as SummaryReducer } from '../features/Summary/reducer'
import { reducer as AppReducer } from '../features/App/reducer'
import { reducer as UnitsReducer } from '../features/Units/reducer'
import { reducer as PortalReducer } from '../features/Portal/reducer'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['app'],
}

const reducers = combineReducers({
  register: RegisterReducer,
  selectUnits: SelectUnitsReducer,
  createLogin: CreateLoginReducer,
  createProfile: CreateProfileReducer,
  login: LoginReducer,
  summary: SummaryReducer,
  app: AppReducer,
  units: UnitsReducer,
  portal: PortalReducer,
  firebase: firebaseReducer,
  AsyncSelector: createReducer(),
})

const sentryEnhancer = Sentry.createReduxEnhancer()
const persistedReducer = persistReducer(persistConfig, reducers)
export const store = configureStore({
  devTools: import.meta.env.DEV
    ? {
        name: 'JustLockIt Client',
        trace: true,
        traceLimit: 25,
      }
    : false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(createMiddleware()),
  reducer: persistedReducer,
  enhancers: [sentryEnhancer],
})

export const persistor = persistStore(store)
window.store = store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type Store = typeof store
